import firebase from 'firebase/compat/app'
import 'firebase/compat/database'
import 'firebase/compat/auth'

// Initialize Firebase
var config = {
  apiKey: "AIzaSyAEXs_DO5S9lyY1pPIz40rn9mP0g-186Q8",
  authDomain: "afa-orders.firebaseapp.com",
  databaseURL: "https://afa-orders.firebaseio.com",
  projectId: "afa-orders"
};
firebase.initializeApp(config);

// Instantiate Auth eagerly, before anything touches database().
// Why: RTDB's FirebaseAuthTokenProvider does getImmediate({optional: true}) for
// Auth, and under the v9+ compat SDK Auth is LAZY -- it stays null until
// something calls firebase.auth(). getToken() then waits exactly one macrotask
// (setTimeout 0) and, still finding nothing, resolves a null token, so the
// socket handshake goes out unauthenticated. Restoring a session from IndexedDB
// takes far longer than one tick. Pages that render <AuthWidget /> called
// firebase.auth() by luck; pages that don't (Numbers, AllUnaccepted) connected
// anonymously and every .once() read of an auth-gated path -- ordersArchive --
// failed with permission_denied and never retried. Touching auth() here makes
// auth_ non-null, so getToken() delegates to Auth's own getToken, which properly
// awaits initialization.
firebase.auth();

// TEMP 2026-05-05: force sign out + reload on app load.
// Why: Firebase Auth v5 SDK tokens are being silently rejected by RTDB today,
// causing a reconnect storm (load went from ~12% to ~52%) and listeners that
// never deliver data. signOut() alone isn't enough — the bad listener is
// already attached and the SDK won't drop it, so a reload is required to
// re-open an unauthenticated connection. Anonymous connections still work.
// Remove once auth path is upgraded.
// const __unsubForceSignOut = firebase.auth().onAuthStateChanged((user) => {
//   __unsubForceSignOut()
//   if (!user) return
//   firebase.auth().signOut()
//     .then(() => window.location.reload())
//     .catch(() => window.location.reload())
// })

export default firebase
